<template>
    <v-card style="box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25)" class="d-flex flex-column">
        <v-layout pa-3 class="titleCard" style="flex: 0">
            <v-flex shrink class="d-flex align-center">
                <v-icon large class="white--text mr-3">bar_chart</v-icon>
            </v-flex>
            <v-flex class="text-left" style="font-size: 20px">
                {{ title }}
            </v-flex>
        </v-layout>
        <v-layout justify-start py-3 px-5 style="background: #FF5100;flex: 0" v-show="maxregion">
            <v-flex shrink class="white--text text-left">
                <div style="font-size: 18px" v-if="maxregion">{{ maxregion }}</div>
            </v-flex>
        </v-layout>
        <v-layout pa-7 style="flex: 1">
            <v-flex class="d-flex align-center">
                <div style="width: 100%">
                    <v-layout justify-space-between mb-3 style="width: 100%">
                        <v-flex shrink style="color: #FF5100;">
                            {{ $t('page.data-stat.industry') }}
                        </v-flex>
                        <v-flex shrink>
                            {{ $t('general.unit') }}: {{ unit }}
                        </v-flex>
                    </v-layout>
                    <canvas :id="`MeSeStatusCanvas-${keyIndex}`"></canvas>
                </div>
            </v-flex>
        </v-layout>

        <template v-if="referenceLink">
            <div class="text-left px-5 mb-5">
                {{ $t('general.reference') }}:
                <span @click="openLink(referenceLink)" class="txt-link">
                    <template v-if="referenceText">
                        <span>{{ referenceText }}</span>
                    </template>
                    <template v-else>
                        <span>{{ referenceLink }}</span>
                    </template>
                </span>
            </div>
        </template>
    </v-card>
</template>

<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        props: ['keyIndex', 'title','year','chartdata', 'options', 'dataname','unit', 'maxregion', 'referenceText', 'referenceLink', 'displayLabels'],

        mounted() {

            Chart.defaults.global.legend.display = false;

            var MeSeContext = document.getElementById(`MeSeStatusCanvas-${this.keyIndex}`).getContext("2d");
            var MeSeData = {
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: '#FF5100',
                        data: this.options,
                        // Change options only for labels of THIS DATASET
                        datalabels: {
                            display: !!this.displayLabels
                        }
                    }
                ]
            };

            new Chart(MeSeContext, {
                type: 'horizontalBar',
                data: MeSeData,
                options: {
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                return this.dataname + ": " + tooltipItem.xLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            }
                        }
                    }
                }
            });
        },
        methods: {
            openLink(url) {
                if (url) {
                    if (url.split('.')[0] === 'www') {
                        window.open(`https://${url}`);
                    } else {
                        window.open(url);
                    }
                }
            },
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            }
        }
    }
</script>

<style scoped>

    .titleCard {
        background: #4F4F4F;
        color: #FFFFFF;
    }

</style>
